import styled from 'styled-components';
import { FLUENT_UI_EMOJIS } from '../../../../../../../../../assets';

export const LanguageIcon = styled(FLUENT_UI_EMOJIS.GLOBE_AHOWING_ASIA_AUSTRALIA)``;
